<template>
  <div class="pc-root">
    <div class="pc-grid">
      <!-- ── Categorias de consumo ── -->
      <div class="pc-card">
        <div class="pc-card-header">
          <button class="pc-nav-btn" @click="$emit('categoria-anterior')">
            ‹
          </button>
          <h3 class="pc-card-title text-capitalize">
            {{ categoriaFormatada || "Sem categoria" }}
          </h3>
          <button class="pc-nav-btn" @click="$emit('categoria-seguinte')">
            ›
          </button>
        </div>

        <div v-if="categoriaAtual && itens.length" class="pc-items">
          <div v-for="(item, i) in itens" :key="i" class="pc-item">
            <div class="pc-item-row">
              <span class="pc-item-name">{{ item.name }}</span>
              <span class="pc-item-pct">{{ item.progress }}%</span>
            </div>
            <div class="pc-bar-wrap">
              <div class="pc-bar" :style="{ width: item.progress + '%' }"></div>
            </div>
            <span class="pc-item-meta"
              >{{ item.unidades_vendidas }} un ·
              {{
                item.total_pago.toFixed
                  ? item.total_pago.toFixed(2)
                  : item.total_pago
              }}€</span
            >
          </div>
        </div>
        <div v-else class="pc-empty">Sem dados a mostrar</div>

        <!-- Paginação interna -->
        <div v-if="categoriaAtual" class="pc-pag">
          <button
            class="pc-pag-btn"
            :disabled="!podePrevCategoria"
            @click="$emit('prev-categoria')"
          >
            ‹
          </button>
          <button
            class="pc-pag-btn"
            :disabled="!podeNextCategoria"
            @click="$emit('next-categoria')"
          >
            ›
          </button>
        </div>
      </div>

      <!-- ── Lista de refeições ── -->
      <div class="pc-card">
        <div class="pc-card-header-simple">
          <h3 class="pc-card-title">Lista de refeições</h3>
        </div>

        <div v-if="visitas.length" class="pc-visitas">
          <div
            v-for="(visita, i) in visitas"
            :key="i"
            class="pc-visita-row"
            @click="$emit('abrir-visita', visita)"
          >
            <div class="pc-visita-badge">
              <span>{{ calcularTempo(visita.data_visita) }}</span>
            </div>
            <div class="pc-visita-info">
              <span class="pc-visita-rest">{{
                visita.restaurante || "Restaurante"
              }}</span>
              <span class="pc-visita-sub"
                >{{ visita.refeicao }} ·
                {{ diaSemana(visita.data_visita) }}</span
              >
            </div>
            <span class="pc-visita-val">{{
              formatarEuro(visita.total_pago || 0)
            }}</span>
            <div class="pc-visita-more">+</div>
          </div>
        </div>
        <div v-else class="pc-empty">Sem dados a mostrar</div>

        <!-- Paginação visitas -->
        <div v-if="totalVisitas > pageSize" class="pc-pag">
          <button
            class="pc-pag-btn"
            :disabled="!podePrevVisitas"
            @click="$emit('prev-visitas')"
          >
            ‹
          </button>
          <span class="pc-pag-info">{{
            Math.ceil(totalVisitas / pageSize) > 1 ? "" : ""
          }}</span>
          <button
            class="pc-pag-btn"
            :disabled="!podeNextVisitas"
            @click="$emit('next-visitas')"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PerfilConsumos",
    props: {
      categoriaAtual: { default: null },
      categoriaFormatada: { type: String, default: "" },
      itens: { type: Array, default: () => [] },
      podePrevCategoria: { type: Boolean, default: false },
      podeNextCategoria: { type: Boolean, default: false },
      visitas: { type: Array, default: () => [] },
      totalVisitas: { type: Number, default: 0 },
      pageSize: { type: Number, default: 5 },
      podePrevVisitas: { type: Boolean, default: false },
      podeNextVisitas: { type: Boolean, default: false },
    },
    methods: {
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(valor) || 0);
      },
      calcularTempo(data) {
        if (!data) return "—";
        return new Date(data).toLocaleDateString("pt-PT", {
          day: "2-digit",
          month: "2-digit",
        });
      },
      diaSemana(d) {
        if (!d) return "";
        return new Date(d).toLocaleDateString("pt-PT", { weekday: "long" });
      },
    },
  };
</script>

<style scoped>
  .pc-root {
    margin-bottom: 16px;
  }
  .pc-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .pc-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
  }
  .pc-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    border-bottom: 1px solid #f5f2ef;
  }
  .pc-card-header-simple {
    padding: 14px 20px;
    border-bottom: 1px solid #f5f2ef;
  }
  .pc-card-title {
    font-size: 14px;
    font-weight: 800;
    color: #ff825d;
    margin: 0;
  }
  .pc-nav-btn {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    font-size: 16px;
    line-height: 1;
    color: #6b6460;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.12s;
  }
  .pc-nav-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
  }

  /* Itens consumo */
  .pc-items {
    padding: 8px 0;
    flex: 1;
  }
  .pc-item {
    padding: 10px 20px;
    border-bottom: 1px solid #faf8f6;
    transition: background 0.08s;
  }
  .pc-item:last-child {
    border-bottom: none;
  }
  .pc-item:hover {
    background: #fdfcfb;
  }
  .pc-item-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 5px;
  }
  .pc-item-name {
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
  }
  .pc-item-pct {
    font-size: 13px;
    font-weight: 700;
    color: #ff825d;
  }
  .pc-bar-wrap {
    height: 4px;
    background: #f0ece8;
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 4px;
  }
  .pc-bar {
    height: 100%;
    background: #ff825d;
    border-radius: 2px;
    transition: width 0.3s;
  }
  .pc-item-meta {
    font-size: 11.5px;
    color: #b0a8a0;
  }

  /* Visitas */
  .pc-visitas {
    flex: 1;
  }
  .pc-visita-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    border-bottom: 1px solid #faf8f6;
    cursor: pointer;
    transition: background 0.08s;
  }
  .pc-visita-row:last-child {
    border-bottom: none;
  }
  .pc-visita-row:hover {
    background: #fdfcfb;
  }
  .pc-visita-badge {
    background: #f8f6f3;
    border-radius: 8px;
    padding: 4px 9px;
    font-size: 11.5px;
    font-weight: 700;
    color: #6b6460;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .pc-visita-info {
    flex: 1;
    min-width: 0;
  }
  .pc-visita-rest {
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .pc-visita-sub {
    font-size: 12px;
    color: #b0a8a0;
  }
  .pc-visita-val {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a1210;
    flex-shrink: 0;
  }
  .pc-visita-more {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1.5px solid #e8e4e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #b0a8a0;
    flex-shrink: 0;
    transition: all 0.12s;
  }
  .pc-visita-row:hover .pc-visita-more {
    border-color: #ff825d;
    color: #ff825d;
  }

  /* Paginação */
  .pc-pag {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 20px;
    border-top: 1px solid #f5f2ef;
  }
  .pc-pag-btn {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    font-size: 16px;
    line-height: 1;
    color: #6b6460;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.12s;
  }
  .pc-pag-btn:hover:not(:disabled) {
    border-color: #ff825d;
    color: #ff825d;
  }
  .pc-pag-btn:disabled {
    opacity: 0.3;
    cursor: default;
  }
  .pc-pag-info {
    font-size: 12px;
    color: #b0a8a0;
    font-weight: 600;
  }

  .pc-empty {
    text-align: center;
    padding: 40px 20px;
    color: #b0a8a0;
    font-size: 13.5px;
    font-style: italic;
  }

  @media (max-width: 768px) {
    .pc-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
